import { gql } from "@apollo/client";

export const AGENT_ALL_WIDGETS_DATA_QUERY = gql`
  query ($agent_id: Long) {
    agentAllWidgetsData(agent_id: $agent_id) {
      responseData {
        latestTopBookings {
          booking_date
          booking_Location
          city
          currency
          service_Name
          total_price
          bid
        }
        salesCurrentLastMonth {
          currentMonthDaywiseSales {
            day
            no_of_Bookings
            sales
          }
          lastMonthDaywiseSales {
            day
            no_of_Bookings
            sales
          }
          salesCurrentLastMonthData {
            currentMonth
            currentMonth_no_of_Bookings
            currentMonthSales
            lastMonth
            lastMonth_no_of_Bookings
            lastMonthSales
          }
        }
        widgetFlaggedBookings {
          after_seventy_two_hours_count
          fourty_eight_hours_count
          seventy_two_hours_count
          twenty_fours_hours_count
        }
        widgetOverallBookings {
          month
          bookings_count
          cancelled_count
        }
      }
      messageDescription
      successTypeCode
      messageCode
    }
  }
`;

export const PREVIEW_URL_QUERY = gql`
  query ($url: String!) {
    previewURL(filePath: $url) {
      responseData {
        url
      }
      successTypeCode
      messageDescription
    }
  }
`;

export const ACTIVITY_CANCELLATION_POLICY_WRAPPER_MUTATION = gql`
  mutation ActivityCancellationPolicy($input: String!) {
    activityCancellationPolicy(input: $input) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData
    }
  }
`;

export const TRANSFER_CANCELLATION_POLICY_WRAPPER_MUTATION = gql`
  mutation TransferCancellationPolicy($input: String!) {
    transferCancellationPolicy(input: $input) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData
    }
  }
`;

export const AGENT_INVOICE_QUERY = gql`
  query ($request: AgentInvoiceListFilterVMInput!) {
    agentInvoice(filter: $request) {
      responseData {
        count {
          total_count
        }
        invoices {
          agent_address1
          agent_address2
          agent_city
          agent_commission_amount_l0
          agent_commission_amount_l1
          agent_commission_percentage_l0
          agent_commission_percentage_l1
          agent_country
          agent_gst_number
          agent_markup_amount
          agent_markup_percentage
          agent_name
          agent_ops_person
          agent_postal_code
          agent_reference
          agent_sales_person
          agent_state
          agency_name
          bid
          booking_date
          booking_id
          booking_reference
          booking_status
          cancel_by_date
          cancellation_date
          cgst
          channel
          convinience_fee
          created_by
          created_on
          credit_card_charges_amount
          credit_card_charges_percentage
          due_date
          gst_state_code
          id
          igst
          invoice_amount
          invoice_currency
          invoice_date
          invoice_document
          invoice_number
          invoice_roe
          irn_number
          # irn_qr_code
          # irn_error
          lead_pax_name
          non_refundable
          number_of_nights
          number_of_rooms
          office_code
          order_id
          pax_number
          pax_list
          pan_list
          place_of_supply
          roundoff
          sale_amount_net
          sale_payable_amount
          sale_roe
          sales_ledger
          sales_type
          service_details
          service
          service_city
          service_country
          service_date_end
          service_date_start
          service_fee
          service_name
          service_type
          settlement_status
          sgst
          started_by
          submission_date
          supplier_markup_amount
          supplier_markup_percentage
          tech_platform_commission_amount_agent
          tech_platform_percentage_agent
          trade_discount
          transaction_id
          updated_by
          updated_on
          vat
          vendor
          vendor_confirmation_number
             rail_onwards_info {
            arrival_date_time
            arrival_station
            departure_date_time
            departure_station
          }
          rail_return_info {
            arrival_date_time
            arrival_station
            departure_date_time
            departure_station
          }
        }
      }
      messageDescription
      successTypeCode
    }
  }
`;
export const HOTEL_PROFORMA_INVOICE_QUERY = gql`query($request:ProformaInvoiceHotelDetailsFilterVMInput!) {
  proformaInvoiceHotelDetails(filter: $request) {
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_commission_amount_l1
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      contact_person
      gst_state_code
      igst
      invoice_currency
      invoice_date
      invoice_description
      invoice_number
      invoice_roe
      irn_qr_code
      bid
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      trade_discount
      vat
      booking_details {
        booking_date
        booking_reference
        checkin_date
        checkout_date
        city_name
        country_name
        hotel_address
        hotel_name
        payment_due_date
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
    messageDescription
  }
}`;
export const ACTIVITY_PROFORMA_INVOICE_QUERY = gql`query ($request: ProformaInvoiceActivityDetailsFilterVMInput!) {
  proformaInvoiceActivityDetails(filter: $request) {
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_commission_amount_l1
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      bid
      contact_person
      gst_state_code
      igst
      invoice_currency
      invoice_date
      invoice_number
      invoice_roe
      irn_number
      irn_qr_code
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      trade_discount
      vat
      invoice_description {
        activity_date
        activity_name
        bid
        booking_date
        booking_reference
        city_name
        country_name
        no_of_adults
        no_of_children
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
    messageDescription
  }
}`;
export const TRANSFER_PROFORMA_INVOICE_QUERY = gql`query ($request: ProformaInvoiceTransferDetailsFilterVMInput!) {
  proformaInvoiceTransferDetails(filter: $request) {
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_commission_amount_l1
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      bid
      contact_person
      gst_state_code
      igst
      invoice_currency
      invoice_date
      invoice_number
      invoice_roe
      irn_number
      irn_qr_code
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      trade_discount
      vat
      invoice_description {
        bid
        booking_date
        booking_reference
        city_name
        country
        dropoff_name
        no_of_adults
        no_of_children
        pickup_date
        pickup_name
        pickup_time
        vehicle_name
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
    messageDescription
  }
}`;
export const EURAIL_PROFORMA_INVOICE_QUERY = gql`query ($request: ProformaInvoiceEurailDetailsFilterVMInput!) {
  proformaInvoiceEurailDetails(filter: $request) {
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_commission_amount_l1
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      bid
      cgst
      contact_person
      gst_state_code
      igst
      invoice_currency
      invoice_date
      invoice_number
      invoice_roe
      irn_number
      irn_qr_code
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      trade_discount
      vat
      invoice_description {
        bid
        booking_date
        booking_reference
        no_of_adults
        no_of_children
        forward_ticket_info {
          arrival_date_time
          arrival_station
          departure_date_time
          departure_station
          description
          ticket_class
        }
        pass_info {
          carrier_class
          country_name
          pass_name
          pass_validity
          validity_end_date
          validity_start_date
        }
        return_ticket_info {
          arrival_date_time
          arrival_station
          departure_date_time
          departure_station
          description
          ticket_class
        }
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
  }
}`;

export const HOTEL_INVOICE_QUERY = gql`query ($request: InvoiceHotelDetailsFilterVMInput!) {
  invoiceHotelDetails(filter: $request) {
    correlationId
    messageCode
    messageDescription
    successTypeCode
    totalRecords
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      contact_person
      gst_state_code
      igst
      invoice_date
      invoice_description
      invoice_number
      irn_qr_code
      irn_number
      invoice_amount
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service_fee
      sgst
      vat
      invoice_currency
      invoice_roe
      agent_commission_amount_l1 
      trade_discount
      telephone
      contact_person
      payment_due_date
      order_id
      transaction_id
      agent_vat_number
      booking_details {
        bid
        booking_date
        booking_reference
        checkin_date
        checkout_date
        city_name
        country_name
        hotel_address
        hotel_name
              }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
      service
    }
  }
}`;
export const EURAIL_INVOICE_QUERY = gql`query ($request: InvoiceEurailDetailsFilterVMInput!) {
  invoiceEurailDetails(filter: $request) {
    messageCode
    messageDescription
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      contact_person
      gst_state_code
      igst
      invoice_date
      invoice_number
      irn_qr_code
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      vat
      invoice_currency
      invoice_roe
      irn_number
      agent_commission_amount_l1 
      trade_discount
      agent_vat_number
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
      invoice_description {
        bid
        booking_date
        booking_reference
        no_of_adults
        no_of_children
        forward_ticket_info {
          arrival_date_time
          arrival_station
          departure_date_time
          departure_station
          description
          ticket_class
        }
        pass_info {
          carrier_class
          country_name
          pass_name
          pass_validity
          validity_end_date
          validity_start_date
        }
        return_ticket_info {
          arrival_date_time
          arrival_station
          departure_date_time
          departure_station
          description
          ticket_class
        }
      }
    }
    successTypeCode
  }
}`;
export const ACTIVITY_INVOICE_QUERY = gql`query ($request:InvoiceActivityDetailsFilterVMInput!) {
  invoiceActivityDetails(filter:$request ) {
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      contact_person
      gst_state_code
      igst
      invoice_date
      invoice_number
      irn_qr_code
      irn_number
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      vat
      invoice_currency
      invoice_roe
      agent_commission_amount_l1 
      trade_discount
      agent_vat_number
      invoice_description {
        bid
        activity_date
        activity_name
        booking_date
        booking_reference
        city_name
        country_name
        no_of_adults
        no_of_children
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
    messageDescription
  }
}`;
export const TRANSFERS_INVOICE_QUERY = gql`query($request:InvoiceTransferDetailsFilterVMInput!) {
  invoiceTransferDetails(filter: $request) {
    messageDescription
    responseData {
      agency_email
      agency_name
      agent_address1
      agent_address2
      agent_city
      agent_country
      agent_gst_number
      agent_postal_code
      agent_reference
      agent_state
      cgst
      contact_person
      gst_state_code
      igst
      invoice_date
      invoice_number
      irn_qr_code
      mobile
      office_code
      place_of_supply
      roundoff
      sale_amount_net
      sale_payable_amount
      service
      service_fee
      sgst
      vat
      invoice_currency
      invoice_roe
      irn_number
      agent_commission_amount_l1 
      trade_discount
      agent_vat_number
      invoice_description {
        bid
        booking_date
        booking_reference
        city_name
        country
        dropoff_name
        no_of_adults
        no_of_children
        pickup_date
        pickup_name
        pickup_time
        vehicle_name
      }
      pax_details {
        age
        first_name
        is_deleted
        is_lead
        last_name
        lead_nationality
        pan
        passport_number
        pax_id
        title
        type
      }
    }
    successTypeCode
  }
}`;

export const GENERATE_INVOICE_PDF_QUERY = gql`
  query GenerateInvoicePdf($invoicePdfVM: InvoicePdfVMInput!) {
    generateInvoicePdf(invoicePdfVM: $invoicePdfVM) {
      bid
      invoice_attachment
      finalhtml
    }
  }
`;

export const GENERATE_CREDIT_NOTE_PDF_QUERY = gql`
  query GenerateCreditNotePdf($invoicePdfVM: InvoicePdfVMInput!) {
    generateCreditNotePdf(invoicePdfVM: $invoicePdfVM) {
      bid
      invoice_attachment
      finalhtml
    }
  }
`;